import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';

interface OptionStyledProps {
  $isDisabled: boolean;
  $isSelected: boolean;
}
export const OptionStyled = styled.li<OptionStyledProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.2rem;
  border-radius: 4px;
  background-color: transparent;
  color: ${colors.neutral[900]};
  cursor: pointer;
  ${typography.regular[16]}

  ${({ $isSelected }): CSSProp =>
    $isSelected &&
    css`
      background-color: ${colors.blue[100]};
      color: ${colors.blue[600]};
    `}

  ${({ $isDisabled }): CSSProp =>
    $isDisabled &&
    css`
      background-color: transparent;
      cursor: not-allowed;
    `}

  ${({ $isDisabled, $isSelected }): CSSProp =>
    !$isDisabled &&
    css`
      &:hover,
      &:focus-visible {
        background-color: ${$isSelected ? colors.blue[200] : colors.neutral[100]};
      }
    `}

  &:focus {
    outline: none;
  }
`;

export const OptionLabelStyled = styled.span<{ $isDisabled: boolean }>`
  ${({ $isDisabled }): CSSProp =>
    $isDisabled &&
    css`
      color: ${colors.neutral[500]};
    `}
`;

export const OptionTagStyled = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
`;
